import React, { useState, useContext } from "react";
import { matchPath } from "react-router";
import { useLocation, Link } from "react-router-dom";
//  External Components
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
//  Icons
import CloseIcon from "@mui/icons-material/CloseOutlined";
import MenuIcon from "@mui/icons-material/Menu";
// Internal
import useStyles from "./useStyles";
import UserContext from "../../UserContext";
export default (function (_a) {
    var menuItems = _a.menuItems;
    var userContext = useContext(UserContext);
    var _b = useState(false), toggle = _b[0], setToggle = _b[1];
    var toggleDrawer = function () { return setToggle(!toggle); };
    var pathname = useLocation().pathname;
    var classes = useStyles();
    var Menu = function () { return (React.createElement(List, null,
        React.createElement(ListItem, null,
            React.createElement(ListItemIcon, null,
                React.createElement(IconButton, { size: "small", color: "secondary", onClick: toggleDrawer },
                    React.createElement(CloseIcon, null))),
            React.createElement(ListItemText, { primary: "VERIFI", primaryTypographyProps: {
                    className: classes.logo,
                    color: "secondary",
                    variant: "h3",
                } })), menuItems === null || menuItems === void 0 ? void 0 :
        menuItems.map(function (_a) {
            var category = _a.category, icon = _a.icon, subItems = _a.subItems;
            return (React.createElement("div", { key: category },
                React.createElement(ListItem, { className: classes.category },
                    React.createElement(ListItemIcon, null, icon),
                    React.createElement(ListItemText, { primary: category, primaryTypographyProps: {
                            color: "secondary",
                            variant: "h3",
                        } })),
                React.createElement(List, { disablePadding: true }, subItems.map(function (_a) {
                    var label = _a.label, route = _a.route, to = _a.to, preferredLocations = _a.preferredLocations, external = _a.external;
                    if (external) {
                        return (React.createElement("a", { className: classes.externalLink, key: label, target: "_blank", href: to, rel: "noreferrer" }, label));
                    }
                    return (React.createElement(ListItem, { classes: {
                            root: classes.hover,
                            selected: classes.selected,
                        }, component: Link, dense: true, key: label, onClick: toggleDrawer, selected: !!matchPath(pathname, {
                            path: route,
                            exact: false,
                            strict: false,
                        }), to: {
                            pathname: to || route,
                            search: preferredLocations,
                        } },
                        React.createElement(ListItemText, { inset: true, primary: label, primaryTypographyProps: {
                                color: "secondary",
                                variant: "h5",
                            } })));
                }))));
        }))); };
    return (React.createElement(React.Fragment, null,
        !(userContext === null || userContext === void 0 ? void 0 : userContext.needsReset) && (React.createElement(IconButton, { size: "small", onClick: toggleDrawer, "aria-label": "Menu" },
            React.createElement(MenuIcon, { color: "secondary", fontSize: "large" }))),
        React.createElement(Drawer, { open: toggle, onClose: toggleDrawer, classes: { paper: classes.paper } },
            React.createElement(Menu, null))));
});
//# sourceMappingURL=index.js.map